export function isSideBarHiddenForUiMode(uiHideMode) {
  return uiHideMode === 'ALL' || uiHideMode === 'ANIMATION';
}
